module.exports = __webpack_public_path__ + "img/logo-poloneked.cbcc9a35.png";